/**
 * @param segments       The DnD positions object, e.g. {A: ["A1","A2"], B: ["B1"]}.
 * @param segmentData    The detailed data for each segment/item, e.g.:
 *   {
 *     A: {
 *       description: "Segment A",
 *       isActive: true,
 *       items: {
 *         A1: {
 *           longDescription: "Item A1 long text",
 *           shortDescription: "Short A1",
 *           responseType: 1,
 *           isActive: false
 *         },
 *         A2: { ... }
 *       }
 *     },
 *     B: { ... }
 *   }
 */
export function buildSegmentsPayload(segments, segmentData) {
  const containerIds = Object.keys(segments);

  // 2) Map each container ID to an object with position, description, items
  const segmentArray = containerIds.map((containerId, containerIndex) => {
    const segInfo = segmentData[containerId] || {};
    const description = segInfo.description || "";

    const itemIds = segments[containerId] || [];

    // Now build the "items" array. We do 1-based "position".
    const itemsArray = itemIds.map((itemId, itemIndex) => {
      const itemInfo = (segInfo.items || {})[itemId] || {};
      const isExistingItem = typeof itemId == "number";

      return {
        id: isExistingItem ? itemId : undefined,
        position: itemIndex + 1,
        description: itemInfo.longDescription || "",
        shortDescription: itemInfo.shortDescription || "",
        responseType: itemInfo.responseType ?? 1,
        isActive: itemInfo.isActive ?? true,
      };
    });

    return {
      id: !containerId.includes("new") ? containerId.split("_")[1] : undefined,
      position: containerIndex + 1,
      description,
      isActive: segInfo.isActive ?? true,
      items: itemsArray,
    };
  });

  return segmentArray;
}

export function buildChecklistTemplateRequest(
  formData,
  segmentsArray,
  templateId
) {
  return {
    id: templateId,
    type: 2, // service type default value always
    description: formData.description,
    brandId: formData.brand === 0 ? null : formData.brand,
    objectType: formData.selectedType,
    operationCode: !!formData.operationCode ? formData.operationCode : null,
    validFrom: formData.validFrom,
    validTill: !!formData.validTill ? formData.validTill : null,
    isAutoSuggest: formData.isAutosuggest,
    isB2CExcluded: formData.isB2CExcluded,
    isMandatory: formData.isMandatory,
    isActive: formData.isActive,
    signatureOutletUserRoleID1:
      formData.signatureOutletUserRoleID1 === 0
        ? null
        : formData.signatureOutletUserRoleID1,
    signatureOutletUserRoleID2:
      formData.signatureOutletUserRoleID2 === 0
        ? null
        : formData.signatureOutletUserRoleID2,
    segments: segmentsArray,
  };
}
